<template>
    <div class="compare-with-tag">
        <div
            v-if="type === 'button'"
            class="compare-with-tag__button"
        >
            <button
                class="compare-with-tag__button__inner"
                @click="doCompare"
            >
                <PtIcon icon="CompareGradient" class="compare-with-tag__button__icon" />
                <span>{{ t('patent-view.compareView.compareWithCurrent') }}</span>
            </button>
        </div>

        <ElTooltip
            v-else
            :visibleArrow="false"
            :enterable="false"
            :content="t('patent-view.compareView.compareWithCurrent')"
            :openDelay="POPPER_OPEN_DELAY"
            placement="top"
        >
            <PtIcon
                icon="CompareGradient"
                class="compare-with-tag__tag"
                @click.stop="doCompare"
            />
        </ElTooltip>
    </div>
</template>

<script setup lang="ts">
import _ from 'lodash';
import { withDefaults, ref } from 'vue';
import { Tooltip as ElTooltip } from 'element-ui';
import { Icon as PtIcon } from 'patsnap-biz';
import { POPPER_OPEN_DELAY } from '@/constants';
import { FetchCompareInit } from '@/infrastructure/api-functions/core-search-api/core-search-api';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { RavenInsertMeta } from 'library-@/services/sentry';
import { useI18n } from '@/composables/use-i18n';
import '@patsnap-ui/icon/assets/CompareGradient.svg';

const { t } = useI18n();

const props = withDefaults(defineProps<{
    type?: string;
    sourcePatentId: string;
    targetPatentId: string;
    relatedId: string;
    searchType: string;
    familyType: string;
    affectType: string;
    otherParams?: {
        sort_type: string;
        sort_order: string;
        semanticId: string;
    };
    page?: number;
    rows?: number;
}>(), {
    type: 'button',
    otherParams: undefined,
    page: 1,
    rows: 20,
});

const isLoading = ref(false);

function doCompare() {
    if (isLoading.value) return;
    RavenInsertMeta('View', 'Enter Patent Comparison From View');
    const service = injectService<FetchCompareInit>(FetchCompareInit);
    service.fetchCompareInit({
        related_id: props.relatedId,
        family_type: props.familyType,
        affect_type: props.affectType,
        type: props.searchType,
        sort_type: props.otherParams?.sort_type,
        sort_order: props.otherParams?.sort_order,
        semantic_id: props.otherParams?.semanticId,
    }).then(res => {
        const compareId = _.get(res, 'compare_id', '');
        if (compareId) {
            const href = `/patent-view/clms'clms/${props.sourcePatentId}'${props.targetPatentId}?compareId=${compareId}&page=${props.page}&rows=${props.rows}&_type=${props.searchType}`;
            const newTab = window.open();
            newTab!.opener = null;
            newTab!.location = href;
        }
    });
}

defineExpose({
    doCompare,
});
</script>

<style lang="scss">
.compare-with-tag {
    display: block;

    .compare-with-tag__tag {
        background-color: $green-primary;
        border-radius: 4px;
        cursor: pointer;
    }

    .compare-with-tag__button {
        cursor: pointer;
        border-radius: 4px;
        background-image: linear-gradient(0deg, #0a3dff, #0dacba, #18ec81);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        padding: 1px;

        &__inner {
            height: 100%;
            width: 100%;
            border-radius: 4px;
            padding: 0 16px 0 8px;
            line-height: 24px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &:hover {
            .compare-with-tag__button__inner {
                background: #ebecf0;
            }
        }
        &__icon {
            margin-right: 4px;
            font-size: 24px;
        }
    }
}
</style>
